module.exports = __webpack_public_path__ + "static/media/details-1.33ab9f1e.jpeg";